import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
} from "@mui/material";
import { teleConsultationModel } from "../Axios/AxiosConfig";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast, Zoom } from "react-toastify";
import LoadingComponent from "../loading"


const CalendarContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
});

const DayBox = styled(Box)(({ theme, isSelected }) => ({
  padding: theme.spacing(2),
  backgroundColor: isSelected ? "#DA6E0B" : "#F1EFEC",
  color: isSelected ? "#fff" : "#000",
  borderRadius: "4px",
  textAlign: "center",
  cursor: "pointer",
  margin: "0 5px",
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: "10px",
  marginRight: "1rem",
  overflow: "auto",
  margin: "2rem",
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "#E7E7DB",
  borderRadius: "10px",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
}));

const TimingCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontWeight: "bold",
  gap: "8px",
}));

const TimingButton = styled(Button)(({ theme }) => ({
  minWidth: "32px",
  height: "32px",
  // borderRadius: '50%',

  backgroundColor: "#C0B7A7",
  color: "white",
}));

const DATE_SIZE = 32;

const ModeCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const ModeButton = styled(Button)(({ theme }) => ({
  marginLeft: "8px",
}));

const Appointments = () => {
  const [selectedDay, setSelectedDay] = useState(dayjs());
  const [currentdate, setcurrentdate] = useState(new Date());
  const [consultationData, setconsultationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);

  const navigate = useNavigate();

  const handleSelectDay = (newValue) => {
    setSelectedDay(newValue);
  };

  const doctorDetailsCookie = Cookies.get("Doctor_details");
  let Doctor_details = {};

  if (doctorDetailsCookie) {
    try {
      Doctor_details = JSON.parse(doctorDetailsCookie);
    } catch (error) {
      console.log("Error parsing Doctor_details cookie:", error);
    }
  }
  const UpdateAppointment = async (AppointmentID, key, value) => {
    try {
      setLoading(true); // Start Loader
      const res = await teleConsultationModel.put("/UpdateOneAppointment", {
        AppointmentID,
        key,
        value,
      });

      if (res?.status === 200) {
        getAppointmentData();
        toast.success("Confirmed Appointment Successfully", {
          position: "top-center",
          limit: 1,
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false); // Stop Loader
    }
  };

  const getAppointmentData = async () => {
    try {
      setLoading(true);
      let res = await teleConsultationModel.post("/getAppointmentbyDate", {
        Date: selectedDay.toISOString().split("T")[0],
        Doc_id: Doctor_details.UID,
      });

      if (res.status == 200) {
        setconsultationData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
    finally{
      setLoading(false);      
    }
  };

  useEffect(() => {
    getAppointmentData();
  }, [selectedDay]);

  function convertTo24Hour(timeStr) {
    const date = new Date("1970-01-01 " + timeStr);
    return date.getHours() * 100 + date.getMinutes();
  }
  const getAllAppointmentData = async () => {
    if (!Doctor_details?.UID) {
      console.error("Doctor UID is missing!", Doctor_details);
      return;
    }

    try {
      setLoading(true);
      const res = await teleConsultationModel.post("/getDoctorsAppointment", {
        Doc_id: Doctor_details.UID,
      });

      if (res.status === 200) {
        setAppointments(res.data || []);
        setFilteredAppointments(res.data || []);
      } else {
        console.error("Failed to fetch appointments:", res.statusText);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Doctor_details?.UID) {
      getAllAppointmentData();
    } else {
      console.error("Doctor UID is missing or undefined");
    }
  }, [Doctor_details?.UID]);

  return (
    <div>
      {loading && <LoadingComponent loading={teleConsultationModel} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
      
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "fit-content",
            margin: "auto",
          }}
        >
          <div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                "& > div": {
                  minWidth: 256,
                  display: "flex",
                  flexDirection: "column",
                },
                "& > div > div, & > div > div > div, & .MuiCalendarPicker-root": {
                  width: 256,
                },
                "& .MuiTypography-caption": {
                  width: DATE_SIZE,
                  margin: 0,
                },
                "& .PrivatePickersSlideTransition-root": {
                  minHeight: DATE_SIZE * 6,
                  marginBottom: 0,
                  paddingBottom: 0,
                },
                '& .PrivatePickersSlideTransition-root [role="row"]': {
                  margin: 0,
                },
                "& .MuiPickersDay-dayWithMargin": {
                  margin: 0,
                },
                "& .MuiPickersDay-root": {
                  width: DATE_SIZE,
                  height: DATE_SIZE,
                },
                height: "20rem",
                marginBottom: 0,
                paddingBottom: 0,
                marginLeft: 1,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                  displayStaticWrapperAs="desktop"
                  openTo="day"
                  views={["day"]}
                  value={selectedDay}
                  onChange={handleSelectDay}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        style: {
                          fontFamily: '"Poppins", sans-serif',
                          fontWeight: 400,
                        },
                      }}
                      sx={{ width: "100%" }}
                    />
                  )}
                  sx={{
                    ".Mui-selected": {
                      backgroundColor: "#7FD67F !important",
                      color: "#3B362A",
                      fontFamily: '"Poppins", sans-serif',
                      fontWeight: 500,
                    },
                    width: "100%",
                    paddingBottom: 0,
                    marginBottom: 0,
                    marginLeft: 2,
                    marginTop: 2,
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                  }}
                />
              </LocalizationProvider>
            </Box>
          </div>
          <Box sx={{ width: 275, marginTop: 2, marginLeft: 3 }}>
            {/* Today Appointments Section */}
            <div className="Today-appointment">
              <div className="Today-appointment-title">
                <div>
                  <p className="date-text" style={{ fontSize: "20px" }}>
                    {selectedDay &&
                      new Date(selectedDay)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/ /g, " ")}
                  </p>
                  <p className="day-text" style={{ fontSize: "20px" }}>
                    {selectedDay &&
                      new Date(selectedDay).toLocaleDateString("en-GB", {
                        weekday: "long",
                      })}
                  </p>
                </div>
                <div className="Appointment-count">
                  {consultationData?.length}
                </div>
              </div>
            </div>
            {/* Total Appointments Section */}
            <div
              className="Today-appointment mt-2 mb-4 shadow-lg hover:shadow-xl transition-shadow rounded-lg p-4 cursor-pointer"
              onClick={() => navigate("/AllAppointments")}
            >
              <div className="Today-appointment-title">
                <div>
                  <p>Total Appointments</p>
                </div>
                <div className="Appointment-count">{appointments?.length}</div>
              </div>
            </div>
          </Box>
        </Box>

        {/* Right Side */}
        <Box sx={{ flex: 2 }} className="list-appointments">
          <TableContainer
            style={{ borderRadius: "8px" }}
            className="AppointmentTable"
          >
            <Table>
              <StyledTableHead>
                <TableRow>
                  <TableCell className="tableheadtitle" align="center">
                    Timing
                  </TableCell>
                  <TableCell className="tableheadtitle">Patient Name</TableCell>
                  {/* <TableCell className="tableheadtitle">Gender</TableCell> */}
                  <TableCell className="tableheadtitle">Age</TableCell>
                  <TableCell className="tableheadtitle">Status</TableCell>
                  <TableCell className="tableheadtitle"></TableCell>
                  <TableCell className="tableheadtitle"></TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {consultationData.length > 0 ? (
                  <>
                    {consultationData
                      ?.sort((a, b) => {
                        if (
                          a.appointment_status === "upcoming" &&
                          b.appointment_status !== "upcoming"
                        )
                          return -1;
                        if (
                          a.appointment_status !== "upcoming" &&
                          b.appointment_status === "upcoming"
                        )
                          return 1;
                        return (
                          convertTo24Hour(a.appointment_time) -
                          convertTo24Hour(b.appointment_time)
                        );
                      })
                      ?.map((row, index) => (
                        <>
                          <TableRow key={index} className="TableRowContainer">
                            <TableCell align="center">
                              {row.appointment_time}
                            </TableCell>
                            
                            <TableCell>{row?.patient_name}</TableCell>
                            
                            <TableCell>{row?.patient_age}</TableCell>

                            <TableCell>
                              {row?.appointment_status}
                            </TableCell>

                            <TableCell align="right">
                              <Button
                                style={{
                                  width: "100%",
                                  textTransform: "none",
                                  borderRadius: "5px",
                                  border: "1px solid #DA6E0B",
                                  color: "#DA6E0B",
                                  fontFamily: "'Poppins', sans-serif",
                                  fontWeight: 500,
                                  padding: "3px",
                                }}
                                component={Link}
                                to={`/Patient/${row.Appointment_id}`}
                              >
                                View Profile
                              </Button>
                            </TableCell>

                            <TableCell>
                              {row?.appointment_status === "upcoming" ? (
                                <Button
                                  style={{
                                    width: "100%",
                                    textTransform: "none",
                                    borderRadius: "0",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    border: "none",
                                    boxSizing: "border-box",
                                    borderRadius: "5px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: "3px",
                                  }}
                                  align="center"
                                  onClick={() =>
                                    UpdateAppointment(
                                      row.Appointment_id,
                                      "status",
                                      "confirmed"
                                    )
                                  }
                                >
                                  Confirm
                                </Button>
                              ) : (
                                <Button
                                  style={{
                                    width: "100%",
                                    textTransform: "none",
                                    borderRadius: "0",
                                    backgroundColor: "#DA6E0B",
                                    color: "white",
                                    border: "none",
                                    boxSizing: "border-box",
                                    borderRadius: "5px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: "3px",
                                  }}
                                  align="center"
                                  href={`/Call/${row?.patient_id}/${row?.consultation_type}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Consult
                                </Button>
                              )}
                            </TableCell>

                          </TableRow>
                        </>
                      ))}
                  </>
                ) : (
                  <div className="NoAppointments flex items-center ">
                    <img
                      src="/icons/clock.png"
                      alt="Time"
                      className="w-6 mb-2 mr-1 items-center"
                    />
                    <p className="text-sm"> No New Appointments</p>
                  </div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
};

export default Appointments;
